import { getAssetPath } from 'themes/jumbo/app/_utilities/helpers';
import useSwalWrapper from 'themes/jumbo/@jumbo/vendors/sweetalert2/hooks';
import { useHistory } from "react-router-dom";

const SubscriptionDialog = ({ Component }: { Component: any }) => {
  const Swal = useSwalWrapper();
  const history = useHistory();

  const sweetAlerts = () => {
    Swal.fire({
      title: 'Your account has limited access!',
      text: 'We have limited your access to some features. Please upgrade your current plan to access this feature.',
      /*imageUrl: getAssetPath(
        `assets/images/subscription.webp`,
        '450x200'
      ),*/
      imageWidth: 450,
      imageHeight: 200,
      imageAlt: 'Custom image',
      confirmButtonText: "Upgrade my plan",
    }).then((result) => {
      result.isConfirmed && history.push("/profile");
    });
  };
  return (
    <Component onClick={sweetAlerts} />
  );
};

export default SubscriptionDialog;
